<template>
  <div class="rect_value" :title="title" style="background: #F4F8FF;">
    <div style="font-weight: 400; font-size: 12px; color: #0e193b">
      {{ title }}
    </div>
    <div style="font-weight: 600; font-size: 14px; color: #0e193b;margin-top:4px;">
      {{ value }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style scoped>
.rect_value {
  width: 100%;
  background: #f4f8ff;
  padding: 10px 28px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
